import { MonitorsService } from './../../services/monitors/monitors.service';
import { Component, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from 'src/app/app.component';
import { Variables } from 'src/app/Models/variables';
import { DataCache } from 'src/app/Helpers/data-cache';

@Component({
  selector: 'app-monitor-configurations',
  templateUrl: './monitor-configurations.component.html',
  styleUrls: ['./monitor-configurations.component.css']
})
export class MonitorConfigurationsComponent implements OnInit {

  monitors = [];
  monitor: any;

  loading = false;
  isVis: boolean;

  page = 1;
  size = 100;

  isLoadMore = true;
  isTask: boolean;
  load = false;
  ismanage = false;

  showdetail = false;

  isadm = false;

  gps = [];

  constructor(
    private router: Router,
    public translate: TranslateService,
    private notificationSvc: NotificationService,
    private confirmationService: ConfirmationService,
    private cookieService: CookieService,
    private appComp: AppComponent,
    private monitorService: MonitorsService
  ) {
    // this.translate.addLangs(['English', 'French']);
    // this.translate.setDefaultLang('English');

    // let browserLang = this.translate.getBrowserLang();

    // const pass = 'ranitessarldev2019';
    // const lang = cookieService.get('goepla-portal-language');
    // if (lang.trim() !== '') {
    //   const declang = CryptoJS.AES.decrypt(lang, pass).toString(CryptoJS.enc.Utf8);
    //   const lg = declang;
    //   browserLang = lg;
    // }

    // if (localStorage.getItem('language') !== null) {
    //   browserLang = localStorage.getItem('language');
    // }
    // this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

    translate.use('English');

    const v = new Variables();
    const p = localStorage.getItem('ups');
    if (p != null) {
      const val = CryptoJS.AES.decrypt(p, v.pass).toString(CryptoJS.enc.Utf8);
      const perm = JSON.parse(val);
      if (perm.includes('NTM.Administration.MonitorTypes') || perm.includes('NTM.Administration.Full')) {
        this.ismanage = true;
      }
      if (perm.includes('NTM.Administration.Full')) {
        this.isadm = true;
      }
    }
    this.getMonitors();
    this.getGroups();
   }

  ngOnInit() {
    localStorage.removeItem('monitor');
    localStorage.removeItem('monitor-id');
  }

  gotoCreateMonitor() {
    this.router.navigateByUrl('/createmonitor');
  }

  getMonitors() {
    this.loading = true;
    this.load = true;
    // tslint:disable-next-line: deprecation
    this.monitorService.getMonitors(this.page, this.size).subscribe((res) => {
      if (res != null) {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < res.length; i++) {
          const v = new Variables();
          const gis = localStorage.getItem('gi');
          const gs = CryptoJS.AES.decrypt(gis, v.pass).toString(CryptoJS.enc.Utf8);
          const gids = JSON.parse(gs);

          let isedit = false;
          if (res[i].typeRoleGroups !== null && res[i].typeRoleGroups.length > 0) {
            for (const val of res[i].typeRoleGroups) {
              if (val.typeRoleGroup.roleName === 'Administrator' && gids.includes(val.typeRoleGroup.groupId)) {
                isedit = true;
              }
            }
          }

          const options = [];
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.MONITORITEMSS').subscribe((res1) => {
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.DELETE').subscribe((res2) => {
              // tslint:disable-next-line: deprecation
              this.translate.get('GENERAL.EDIT').subscribe((res3) => {
                if (isedit === true || this.isadm === true) {
                  options.push({label: res3, value: 'Edit'});
                }
                options.push({label: res1, value: 'MonitorItems'});
                options.push({label: 'Detail', value: 'Detail'});
                if (this.isadm === true) {
                  options.push({label: res2, value: 'Delete'});
                }

                if (this.ismanage === true) {
                  res[i].options = options;
                }
                this.monitors.push(res[i]);
              });
            });
          });
        }
        if (res.length < this.size) {
          this.isLoadMore = true;
        } else {
          this.isLoadMore = false;
        }
      } else {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.NOMONITORCONFIGURATIONS').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 3000);
          this.isLoadMore = true;
        });
      }
      this.loading = false;
      this.load = false;
    }, err => {
      this.handleError(err);
    });
  }

  loadMore() {
    this.page += 1;
    this.getMonitors();
  }

  // tslint:disable-next-line: no-shadowed-variable
  saveMonitor(event, monitor) {
    localStorage.setItem('monitor', JSON.stringify(monitor));

    if (event.value === 'Edit') {
      this.router.navigateByUrl('editmonitor');
    } else if (event.value === 'MonitorItems') {
      localStorage.setItem('monitor-id', monitor.monitorId);
      this.router.navigateByUrl('monitoritems');
    } else if (event.value === 'Delete') {
      this.deleteMonitor(monitor);
    } else if (event.value === 'Detail') {
      monitor.g = null;
      if (monitor.typeRoleGroups !== null && monitor.typeRoleGroups.length > 0) {
        for (const val of monitor.typeRoleGroups) {
          val.typeRoleGroup.g = null;
          if (this.gps !== undefined && this.gps !== null && this.gps.length > 0) {
            for (const g of this.gps) {
              if (val.typeRoleGroup.groupId === g.groupId) {
                val.typeRoleGroup.g = g.groupName;
              }
            }
          }
        }
      }
      this.monitor = monitor;
      this.showdetail = true;
    }
  }

  // tslint:disable-next-line: no-shadowed-variable
  deleteMonitor(monitor) {
    this.load = true;
    // tslint:disable-next-line: deprecation
    this.monitorService.deleteMonitor(monitor.monitorId).subscribe(async (res) => {
      if (res === true) {
        await this.appComp.loadMenuAgain();
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.MONITORDELETED').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 3000);
        });
        this.monitors = [];
        this.getMonitors();
      } else {
        this.load = false;
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.COULDNOTDELETEMONITOR').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 3000);
        });
      }
    }, err => {
      this.handleError(err);
    });
  }

  getGroups() {
    DataCache.groupdata$.subscribe(data => {
      if (data !== undefined && data !== null && data.length > 0) {
        for (const val of data) {
          this.gps.push(val);
        }
      }
    });
  }

  confirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        accept: () => {
            // Actual logic to perform a confirmation
        }
    });
  }

  handleError(err) {
    this.load = false;
    this.loading = false;
    // tslint:disable-next-line: max-line-length
    if (err.error.Message === '23503: update or delete on table "t_ntm_monitor" violates foreign key constraint "t_ntm_monitor_item_monitor_id_fkey" on table "t_ntm_monitor_item"') {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.MONITORSDEPENDS').subscribe((res) => {
        this.confirm(res);
      });
    }
  }

}
